import styled from 'styled-components';

import { OnboardingPage } from '../../../../components/Page';

export const ScreenHairColorStyles = styled(OnboardingPage)`
  .local-title {
    margin: 20px auto 40px;
  }

  ion-content {
    --overflow: visible;

    &::part(scroll) {
      overflow: visible;
    }
  }
`;
